import React, { useState, useRef } from 'react';
import axios from 'axios';
import Turnstile from '../../components/Turnstile';
import logo_dark from '../../assets/images/logo-dark.png';
import logo_light from '../../assets/images/logo-light.png';
import { Link } from "react-router-dom";

export default function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [captchaToken, setCaptchaToken] = useState('');
    const captchaRef = useRef(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');

        if (!captchaToken) {
            setError('Please complete the captcha');
            return;
        }

        setLoading(true);

        try {
            const response = await axios.post('https://nifty-art.com/api/password-reset/request', { email, captchaToken });
            setMessage(response.data.message);
        } catch (err) {
            setError(err.response?.data?.message || 'Something went wrong. Please try again.');
        } finally {
            // Токен Turnstile одноразовый — сбрасываем после любой отправки
            captchaRef.current?.reset();
            setLoading(false);
        }
    };

    return (
        <>
            <section className="md:h-screen py-36 flex items-center bg-[url('../../assets/images/cta.jpg')] bg-no-repeat bg-center">
                <div className="container">
                    <div className="flex justify-center">
                        <div className="max-w-[400px] w-full m-auto p-6 bg-white dark:bg-slate-900 shadow-md dark:shadow-gray-800 rounded-md">
                            <Link to="#">
                                <img src={logo_dark} className="mx-auto h-7 block dark:hidden" alt="logo" />
                                <img src={logo_light} className="mx-auto h-7 dark:block hidden" alt="logo" />
                            </Link>
                            <h5 className="my-6 text-xl font-semibold">Forgot Your Password?</h5>
                            <p className="text-slate-400 mb-6">Enter your email address and we'll send you a link to reset your password.</p>

                            {message && <p className="text-green-500 mb-4">{message}</p>}
                            {error && <p className="text-red-500 mb-4">{error}</p>}

                            <form className="text-start" onSubmit={handleSubmit}>
                                <div className="grid grid-cols-1">
                                    <div className="mb-4">
                                        <label className="font-semibold" htmlFor="email">Email Address:</label>
                                        <input 
                                            id="email" 
                                            type="email" 
                                            className="form-input w-full text-[15px] py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded-full outline-none border border-gray-200 focus:border-violet-600 dark:border-gray-800 dark:focus:border-violet-600 focus:ring-0 mt-3" 
                                            placeholder="name@example.com"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <Turnstile ref={captchaRef} onVerify={setCaptchaToken} />

                                    <div className="mb-4">
                                        <button 
                                            type="submit" 
                                            className="btn bg-violet-600 hover:bg-violet-700 border-violet-600 hover:border-violet-700 text-white rounded-full w-full" 
                                            disabled={loading}
                                        >
                                            {loading ? 'Sending...' : 'Send Reset Link'}
                                        </button>
                                    </div>

                                    <div className="text-center">
                                        <span className="text-slate-400 me-2">Remember your password?</span>
                                        <Link to="/login" className="text-black dark:text-white font-bold">Sign in</Link>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
